import SkeletonComponent from '@atoms/SkeletonComponent';
import { View } from '@components/primitives';
import appStyles from '@root/appStyles';
import React from 'react';

const ShimmerMultiColumnNominal: React.FC = () => (
  <View>
    {['shimmer-1', 'shimmer-2', 'shimmer-3', 'shimmer-4'].map(o => (
      <View key={o} flexDirection="row">
        <SkeletonComponent style={appStyles.flex1} />
        <SkeletonComponent style={appStyles.flex1} />
      </View>
    ))}
  </View>
);

export default ShimmerMultiColumnNominal;
